import { useState, useEffect, useCallback } from 'react';
import api from '../services/api';

/**
 * Hook personnalisé pour gérer le filtre de date de présence
 * Charge les statistiques de présence pour une date donnée
 */
export const usePresenceFilter = (initialDate = null) => {
  const [presenceDate, setPresenceDate] = useState(
    initialDate || new Date().toISOString().slice(0, 10)
  );
  const [presenceStats, setPresenceStats] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  // Fonction pour charger les statistiques de présence pour une date spécifique
  const loadPresenceData = useCallback(async (date) => {
    try {
      setLoading(true);
      setError(null);
      
      // Appeler l'API avec le paramètre de date
      const response = await api.dashboard.dg({ date });
      
      if (response && response.stats) {
        setPresenceStats(response.stats);
      }
      
      setLoading(false);
    } catch (err) {
      console.error('Erreur lors du chargement des données de présence:', err);
      setError(err);
      setLoading(false);
    }
  }, []);

  // Charger les données à chaque changement de date
  useEffect(() => {
    loadPresenceData(presenceDate);
  }, [presenceDate, loadPresenceData]);

  // Fonction pour changer la date
  const handleDateChange = useCallback((newDate) => {
    setPresenceDate(newDate);
  }, []);

  return {
    presenceDate,
    setPresenceDate: handleDateChange,
    presenceStats,
    loading,
    error,
    reload: () => loadPresenceData(presenceDate),
  };
};
